import { render, staticRenderFns } from "./BlackListGlobals.vue?vue&type=template&id=4123ff7b&"
import script from "./BlackListGlobals.vue?vue&type=script&lang=ts&"
export * from "./BlackListGlobals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports